var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.086,
    height: 81,
    viewBox: "0 0 81.086 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coin",
    transform: "translate(0.199 0.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "translate(0.301 0.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80543",
    "data-name": "Path 80543",
    d: "M204.286,130.3a40.025,40.025,0,0,1-39.161,48.32,50.5,50.5,0,0,1-15.242-3.01,2.345,2.345,0,1,1,1.495-4.446c.031.011.063.022.094.034a45.944,45.944,0,0,0,13.654,2.731,35.162,35.162,0,0,0,34.423-27.323,35.7,35.7,0,0,0,.156-15.339,35.037,35.037,0,0,0-4.282-10.874,2.345,2.345,0,0,1,4.018-2.42,39.739,39.739,0,0,1,4.847,12.326Z",
    transform: "translate(-125.148 -98.62)",
    fill: "#02fdb1",
    stroke: "#02fdb1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80544",
    "data-name": "Path 80544",
    d: "M68.746,12.153a2.345,2.345,0,0,1-3.336,3.3A35.334,35.334,0,1,0,15.231,65.209a2.346,2.346,0,1,1-3.324,3.311A40.025,40.025,0,1,1,68.746,12.153Z",
    transform: "translate(-0.301 -0.311)",
    fill: "#02fdb1",
    stroke: "#02fdb1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80545",
    "data-name": "Path 80545",
    d: "M94.136,64.14a30,30,0,1,1-30,30A30.031,30.031,0,0,1,94.136,64.14Zm25.306,30a25.306,25.306,0,1,0-25.35,25.306h.044A25.335,25.335,0,0,0,119.442,94.136Z",
    transform: "translate(-54.159 -54.161)",
    fill: "#02fdb1",
    stroke: "#02fdb1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80546",
    "data-name": "Path 80546",
    d: "M-3.984-14.016A6.129,6.129,0,0,0-2.4-9.792l5.232-1.536a2.9,2.9,0,0,1-.864-2.016c0-1.776,1.488-2.832,3.168-4.08,2.3-1.584,4.848-3.5,4.848-7.488C9.984-29.376,6.192-32.5,0-32.5A13.731,13.731,0,0,0-10.512-27.84l3.888,4.368a7.673,7.673,0,0,1,5.9-2.976c2.64,0,3.744,1.248,3.744,2.736,0,1.44-1.3,2.352-2.784,3.408C-1.68-18.912-3.984-17.328-3.984-14.016Zm0,10.656A3.934,3.934,0,0,0-.1.528,3.934,3.934,0,0,0,3.792-3.36,3.934,3.934,0,0,0-.1-7.248,3.934,3.934,0,0,0-3.984-3.36Z",
    transform: "translate(40.241 55.96)",
    fill: "#02fdb1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.6eab4bb56c15734d18bc182cb4dad66c.svg";
export { ForwardRef as ReactComponent };